export default __webpack_public_path__ + "assets/community-one-four-small.eff31a1c7375b7cb155bfc408a36f077.png";